export const examAdminAuditLogs = {
  titleAll: "审计日志",
  titleLogin: "登录日志",
  titleOperation: "操作日志",
  subtitleAll: "覆盖主链路写操作的审计留痕",
  subtitleLogin: "仅展示认证模块日志",
  subtitleOperation: "展示除认证外的操作日志",
  drawer: {
    title: "日志 #{id}",
    detailJson: "detail_json",
    technicalFields: "技术字段（排障）",
  },
  columns: {
    id: "ID",
    time: "时间",
    actor: "操作人",
    loginResult: "登录结果",
    loginAudience: "登录身份",
    loginIp: "登录 IP",
    loginResolution: "分辨率",
    loginUa: "浏览器 UA",
    loginOs: "操作系统",
    loginBrowser: "浏览器",
    loginDpr: "像素比",
    loginTimezone: "时区",
    loginLanguage: "语言",
    failureReason: "失败原因",
    operationResult: "结果",
    operationIp: "操作 IP",
    operationUa: "浏览器 UA",
    xForwardedFor: "转发 IP 链",
    xRealIp: "真实 IP",
    referer: "来源页",
    origin: "来源域",
    module: "模块",
    action: "动作",
    resource: "资源",
    relation: "关联",
    objectType: "对象类型",
    objectIdentifier: "对象标识",
    summary: "摘要",
  },
  audience: {
    staff: "考务人员",
    candidate: "考生",
  },
  stats: {
    total: "共 {count} 条",
    moduleCount: "模块数",
    resultGroup: "结果",
    audienceGroup: "登录身份",
    summaryUnavailable: "图例计数加载失败，图例计数暂不可用",
  },
  result: {
    success: "成功",
    failed: "失败",
    unknown: "未知",
  },
  actions: {
    updateUserPreferences: "更新用户偏好设置",
  },
  meta: {
    os: {
      windows: "Windows",
      macos: "macOS",
      android: "Android",
      ios: "iOS",
      linux: "Linux",
      other: "其他",
    },
    browser: {
      edge: "Edge",
      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",
      other: "其他浏览器",
    },
  },
  filters: {
    actorUserId: "操作人 ID",
    module: "模块",
    action: "动作",
    resourceType: "资源类型",
    resourceId: "资源 ID",
    examId: "考试 ID",
    attemptId: "Attempt ID",
    limit: "条数",
  },
};
